import { useSelector, useDispatch } from 'react-redux';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { selectLayout, setCollapsed } from '@src/store/layout/layoutSlice';
// import { NavbarInfo } from './NavbarInfo';
import { useMediaQuery } from 'react-responsive';
import { screenSize } from '@src/constants/ScreenSize';
import { IoNotificationsCircleOutline } from 'react-icons/io5';
import { HiShoppingBag } from 'react-icons/hi2';
import { useEffect, useState } from 'react';
import { NotificationList } from '@src/pages/notification';
import { Modal } from '@src/components/ui';
import { Badge } from 'antd';
import { Link } from 'react-router-dom';
import { useLazyGetCartQuery } from '@src/services/cart/cart.slice';
import { useLazyGetNotificationsQuery } from '@src/services/notification/notificationApiSlice';
import { ReactComponent as LogoIcon } from '@src/assets/icons/Logo.svg';
import clsx from 'clsx';

export default function Navbar() {
    const dispatch = useDispatch();
    const layout = useSelector(selectLayout);
    const [showNotifications, setShowNotifications] = useState(false);
    const isMdOrMore = useMediaQuery({ minWidth: screenSize.lg });
    const [getCartList, { data: cartData }] = useLazyGetCartQuery();
    const [getNotificationList, { data: notificationData }] =
        useLazyGetNotificationsQuery();
    useEffect(() => {
        getNotificationList({ page: 1, limit: 1 });
        getCartList();
    }, []);
    return (
        <div className={'bg-blue block w-full sm:h-[70px] h-9 relative'}>
            <div
                className={clsx(
                    'flex items-center  justify-between sm:py-4 sm:ps-2 sm:pe-1 px-8 py-0',
                    { '!px-2': layout.collapsed },
                    {
                        'max-w-[200px] w-[200px] min-w-[200px]':
                            !layout.collapsed,
                    }
                )}
            >
                <div className="flex items-center w-full justify-between">
                    <button
                        className=" hover:fill-darkBlue  transition-all cursor-pointer sm:ml-2"
                        onClick={() =>
                            dispatch(setCollapsed(!layout.collapsed))
                        }
                    >
                        <HiOutlineMenuAlt2 className="w-8 h-10  active:opacity-40 fill-white" />
                    </button>
                    {/* {(!layout.collapsed || !isMdOrMore) && ( */}
                    {(!layout.collapsed || !isMdOrMore) && (
                        <LogoIcon
                            width={90}
                            height={32}
                            className={'absolute max-lmd:right-4 right-1'}
                        />
                    )}
                </div>
                {/* <div className="hidden md:flex items-center gap-2">
                    <div className="md:flex items-center gap-4 p-2 rounded-xl bg-[#4C4C4C0A]">
                        <Badge
                            size="small"
                            count={notificationData?.total}
                            showZero
                        >
                            <IoNotificationsCircleOutline
                                className="text-red-400 hover:transform hover:scale-110 transition-all ease-in-out cursor-pointer"
                                size={32}
                                onClick={() => setShowNotifications(true)}
                            />
                        </Badge>
                        <Badge
                            size="small"
                            count={
                                (cartData?.items?.length || 0) +
                                (cartData?.topUpItems?.length || 0)
                            }
                            showZero
                            color="#233ac2"
                        >
                            <Link
                                to="/dashboard/cart"
                                className="w-7 h-7 m-[2.5px] rounded-full border-[3px] border-primary-main flex items-center justify-center"
                            >
                                <HiShoppingBag
                                    className="text-primary-main hover:transform hover:scale-110 transition-all ease-in-out cursor-pointer"
                                    size={16}
                                />
                            </Link>
                        </Badge>
                    </div>
                    <NavbarInfo />
                </div> */}
            </div>
            {showNotifications && (
                <Modal
                    open={showNotifications}
                    onCancel={() => setShowNotifications(false)}
                >
                    <NotificationList />
                </Modal>
            )}
        </div>
    );
}
